import { Phone, Mail, Check } from "lucide-react";
import EmailLink from "@/components/EmailLink";

const contactOptions = [
  { icon: Phone, label: "PHONE / TEXT", value: "(615) 807-0618", href: "tel:+16158070618", note: "Call or text anytime" },
  { icon: Mail, label: "EMAIL", value: "hello@kinshipcarecollective.com", href: "email", note: "For detailed questions" },
];

const firstConversation = [
  "We listen to your situation, in your words",
  "Talk through what would actually help",
  "Answer any questions — about cost, caregivers, anything",
  "Explain our approach clearly",
  "Tell you honestly if we're the right fit",
  "Zero pressure, no obligation",
];

const ContactSection = () => (
  <section className="py-20 md:py-28 bg-background">
    <div className="container">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-center mb-3">
          Let's Have a Conversation
        </h2>
        <p className="text-muted-foreground text-center mb-12 max-w-2xl mx-auto">
          A free, no-pressure call to understand what matters to you — and how we might help. Family welcome to join.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12 max-w-2xl mx-auto">
          {contactOptions.map((opt, i) => {
            const inner = (
              <>
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                  <opt.icon className="h-5 w-5 text-primary" />
                </div>
                <p className="text-xs font-semibold tracking-wider text-muted-foreground mb-2">{opt.label}</p>
                <p className="font-semibold text-foreground text-sm sm:text-base mb-1 break-words">
                  {opt.href === "email" ? (
                    <>hello<span aria-hidden="true">&#64;</span>kinshipcarecollective.com</>
                  ) : (
                    opt.value
                  )}
                </p>
                <p className="text-muted-foreground text-sm">{opt.note}</p>
              </>
            );
            const cardClass =
              "bg-background rounded-xl p-8 border border-border text-center hover:shadow-md transition-shadow block overflow-hidden";
            return opt.href === "email" ? (
              <EmailLink key={i} className={cardClass}>
                {inner}
              </EmailLink>
            ) : (
              <a key={i} href={opt.href} className={cardClass}>
                {inner}
              </a>
            );
          })}
        </div>

        <div className="bg-background rounded-xl p-8 border border-border max-w-2xl mx-auto">
          <h3 className="font-heading font-semibold text-lg mb-4 text-center">What the First Conversation Looks Like</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {firstConversation.map((item, i) => (
              <div key={i} className="flex items-start gap-2">
                <Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                <p className="text-muted-foreground text-sm">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ContactSection;
